import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["img", "counter"]
    currentIndex = 0

    connect() {
        this._hideAllExceptCurrent()
        this._updateCounter()
    }

    next() {
        this.currentIndex = (this.currentIndex + 1) % this.imgTargets.length
        this._hideAllExceptCurrent()
        this._updateCounter()
    }

    previous() {
        this.currentIndex = (this.currentIndex - 1 + this.imgTargets.length) % this.imgTargets.length
        this._hideAllExceptCurrent()
        this._updateCounter()
    }

    _hideAllExceptCurrent() {
        this.imgTargets.forEach((img, i) => {
            img.classList.toggle("hidden", i !== this.currentIndex)
        })
    }

    _updateCounter() {
        this.counterTarget.textContent = `${this.currentIndex + 1} / ${this.imgTargets.length}`
    }
}
